import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import VipTag from '@/components/VipTag.vue';
import {useRoute, useRouter} from 'vue-router';
import {Toast} from 'vant';
import {onMounted} from 'vue';
import {getPoster} from '@/api/miscellaneous';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyHeader',
  props: {
    detail: {
        type: Object,
        Default: () => ({}),
    },
    type: {
        type: String,
        Default: () => 'Shop',
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props

const router = useRouter();
const route = useRoute();
const isShowshare = ref<any>(false);
const isShowOpen = ref<any>(false);
const isShowtousu = ref<any>(false);
const imageurl = ref<any>('');


onMounted(() => {
    console.log(props, '--props');
});

const addparse = (address: any) => {
    return address.substring(0, address.indexof('市'));
};

const tousu = () => {
    router.push({name: 'Report', query: {id: props.detail?.id}});
};
const createPic = () => {
    const {id} = route.query;
    getPoster({id: id as string, type: props.type as string}).then(res => {
        imageurl.value = res as string;
        console.log(res, '--getPoster');
        isShowshare.value = true;
    });
    //isShowshare.value = true;
};
const close = () => {
    isShowshare.value = false;
};
const share = () => {
    isShowOpen.value = true;
};
const save = () => {
    Toast('请长按图片，选择保存');
};

const __returned__ = { router, route, isShowshare, isShowOpen, isShowtousu, imageurl, props, addparse, tousu, createPic, close, share, save, ref, VipTag, useRoute, useRouter, Toast, onMounted, getPoster }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})